import React from "react";
import Chart from "react-apexcharts";

const ChatsGraph = ({ tickets, name, ...props }) => {

  const options = {
    chart: {
      type: 'line',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    xaxis: {
      type: 'datetime',
      categories: tickets.days,
      tickAmount: 1,
      labels: {
        formatter: function (value, timestamp, opts) {
          return opts.dateFormatter(new Date(timestamp), 'dd MMM')
        }
      }
    },
    labels: tickets.days,
    colors: ["#048A89"],
    legend: {
      show: false
    },
    yaxis: {
      show: 1,
      decimalsInFloat: 3,
      forceNiceScale: true
    },
    xaxis: {
      labels: {
        show: 1
      },
      axisTicks: {
        show: 1
      },
      axisBorder: {
        show: 1
      },
      tooltip: {
        enabled: false
      },
    }
  };

  const monthOptions = {
    chart: {
      type: 'line',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    xaxis: {
      type: 'datetime',
      categories: tickets.days,
      tickAmount: 5,
      labels: {
        show: 1,
        rotate: 0,
        rotateAlways: false,
      },
      axisTicks: {
        show: 1
      },
      axisBorder: {
        show: 1
      },
      tooltip: {
        enabled: false
      }
    },
    labels: tickets.days,
    colors: ["#048A89"],
    legend: {
      show: false
    },
    yaxis: {
      show: 1,
      decimalsInFloat: 3,
      forceNiceScale: true
    },
  };

  const series = [{
    name: name,
    data: tickets.model_data,
  }]

  return (
    <Chart
      options={(props.chatFilter == 7 || props.fineTuningFilter == 7) ? options : monthOptions}
      series={series}
      height="300"
    />
  );
}

export default ChatsGraph;